import { useQuery } from '@tanstack/react-query';
import { getNotificationPreferences } from '../../api/apiNotifications';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetNotificationPreferences = () => {
    const { isAuthenticated } = useAuthContext();
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['notification-preferences'],
        queryFn: getNotificationPreferences,
        enabled: isAuthenticated,
        staleTime: 1000 * 60,
    });

    // The endpoint returns the matrix directly under data.data.
    const preferences = data?.data?.data || {};
    return { preferences, isLoading, error, refetch };
};

export default useGetNotificationPreferences;
